export * from './translate';

export { default } from './i18nModule';
